import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_logged = _resolveComponent("home-logged")
  const _component_home_not_logged = _resolveComponent("home-not-logged")

  return (_ctx.isLogged)
    ? (_openBlock(), _createBlock(_component_home_logged, { key: 0 }))
    : (_openBlock(), _createBlock(_component_home_not_logged, { key: 1 }))
}